import { inject, Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  Router,
  UrlTree,
} from '@angular/router';
import { ProjectService } from '../shared/services/project/project.service';

@Injectable({ providedIn: 'root' })
export class ProjectGuard implements CanActivate, CanActivateChild {
  private readonly projectService = inject(ProjectService);
  private readonly router = inject(Router);

  async check(): Promise<boolean | UrlTree> {
    const startupProject = await this.projectService.projectReady$;
    if (
      this.projectService.currentProject() !== null ||
      startupProject !== null
    ) {
      return true;
    }
    return this.router.createUrlTree(['/']);
  }

  canActivate(): Promise<boolean | UrlTree> {
    return this.check();
  }

  canActivateChild(): Promise<boolean | UrlTree> {
    return this.check();
  }
}
